import * as React from 'react'

const SvgLaunchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 17.5H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h5.625v1.25H3.75v12.5h12.5v-5.625h1.25v5.625c0 .69-.56 1.25-1.25 1.25zM13.125 1.25V2.5h3.494L11.25 7.869l.881.881L17.5 3.381v3.494h1.25V1.25h-5.625z"
      fill="#163250"
    />
  </svg>
)

export default SvgLaunchIcon
